export default "__VITE_ASSET__DKtLMtQT__"